import api from 'api/apiInstance';

export function clientAuditTrailPrintApi(path: string) {
  return {
    path,
    GET: () => api.get(path),
  };
}
